import { useDashboardData } from "../../../context/DashboardContext";
import { StatCard } from "../../StatCard";
import type { WidgetComponentProps } from "../types";

const formatCurrency = (value: number) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(value);
const formatPercent = (value: number) => `${value.toFixed(1)}%`;
const formatNumber = (value: number) => value.toLocaleString();

type FormatType = "currency" | "percent" | "number";

const formatters: Record<FormatType, (v: number) => string> = {
  currency: formatCurrency,
  percent: formatPercent,
  number: formatNumber,
};

export default function StatWidget({ config, title }: WidgetComponentProps) {
  const { metrics } = useDashboardData();

  const metricKey = config.metricKey as string;
  const format = (config.format as FormatType) || "number";

  const value = metrics[metricKey] ?? 0;
  const formatter = formatters[format] || formatNumber;

  return <StatCard label={title} value={formatter(value)} index={0} />;
}
